<div class="flex justify-end lg:-mt-[60px]">
  <app-date-filter-pill
    [filter]="(dateFilter | async)!"
    (filterChanged)="dateFilter.next($event)"
  ></app-date-filter-pill>
</div>

<div class="flex flex-col gap-8 mt-4">
  <app-card>
    <app-card-content>
      <h2 class="text-lg leading-6 font-medium text-fg-primary">Projekte</h2>
      <app-two-col-description-list>
        <app-description-list-entry
          label="Total"
          [value]="totalMinutes | formatMinutes"
        ></app-description-list-entry>
        <app-description-list-entry
          label="Total verrechenbar"
          [value]="billableMinutes | formatMinutes"
        ></app-description-list-entry>
        <app-description-list-entry
          label="Total nicht verrechenbar"
          [value]="unbillableMinutes | formatMinutes"
        ></app-description-list-entry>
      </app-two-col-description-list>

      <app-project-stats-table>
        @for (project of projectStats; track project) {
          <tr
            app-project-stats-row
            [projectName]="project.projectName"
            [totalMinutes]="project.totalMinutes"
            [billableMinutes]="project.billableMinutes"
            [unbillableMinutes]="project.unbillableMinutes"
          ></tr>
          @for (position of project.positionStats; track position) {
            <tr
              app-position-stats-row
              title="Position"
              [positionName]="position.positionName"
              [totalMinutes]="position.totalMinutes"
              [billableMinutes]="position.billableMinutes"
              [unbillableMinutes]="position.unbillableMinutes"
            ></tr>
          }
        }
      </app-project-stats-table>
    </app-card-content>
  </app-card>

  <h2 class="text-lg leading-6 font-medium text-fg-primary">Mitarbeiter</h2>

  @for (user of userStats; track user) {
    <app-card>
      <app-card-content>
        <h2 class="text-sm leading-6 font-medium text-fg-primary">
          {{ user.displayName }}
        </h2>
        <app-two-col-description-list>
          <app-description-list-entry
            label="Total"
            [value]="user.totalMinutes | formatMinutes"
          ></app-description-list-entry>
          <app-description-list-entry
            label="Total verrechenbar"
            [value]="user.billableMinutes | formatMinutes"
          ></app-description-list-entry>
          <app-description-list-entry
            label="Total nicht verrechenbar"
            [value]="user.unbillableMinutes | formatMinutes"
          ></app-description-list-entry>
        </app-two-col-description-list>
        <app-project-stats-table>
          @for (project of user.projectsStats; track project) {
            <tr
              app-project-stats-row
              [projectName]="project.projectName"
              [totalMinutes]="project.totalMinutes"
              [billableMinutes]="project.billableMinutes"
              [unbillableMinutes]="project.unbillableMinutes"
            ></tr>
            @for (position of project.positionStats; track position) {
              <tr
                app-position-stats-row
                title="Position"
                [positionName]="position.positionName"
                [totalMinutes]="position.totalMinutes"
                [billableMinutes]="position.billableMinutes"
                [unbillableMinutes]="position.unbillableMinutes"
              ></tr>
            }
          }
        </app-project-stats-table>
      </app-card-content>
    </app-card>
  }
</div>
